import { AbstractControl, ValidatorFn } from '@angular/forms';

export class TimeRangeValidators {
    static isTimeRangeValidValidator = (hoursKey: string, minutesKey: string): ValidatorFn => {
        return (control: AbstractControl): { [key: string]: unknown } | null => {
            const hoursPattern = /^([01]\d|2[0-3])$/; // Matches 00 to 23
            const minutesPattern = /^(0[0-9]|[1-5][0-9])$/; // Matches 00 to 59

            const hours = control.get(hoursKey)?.value;
            const minutes = control.get(minutesKey)?.value;

            if (!hours || !minutes) {
                return { invalidTime: true };
            }

            if ((hours && !hoursPattern.test(hours)) || (minutes && !minutesPattern.test(minutes))) {
                return { invalidTime: true };
            }

            return null;
        };
    };
}